import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TeamSection } from '../types';

export interface TeamDirectoryState {
  data: TeamSection[];
  loading: boolean;
  error: string | null;
  fetched: boolean;
  fetchAttempted: boolean;
}

const initialState: TeamDirectoryState = {
  data: [],
  loading: false,
  error: null,
  fetched: false,
  fetchAttempted: false,
};

const teamDirectorySlice = createSlice({
  name: 'teamDirectory',
  initialState,
  reducers: {
    fetchTeamDirectoryRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.fetchAttempted = true;
    },
    fetchTeamDirectorySuccess: (state, action: PayloadAction<TeamSection[]>) => {
      state.loading = false;
      state.data = action.payload;
      state.error = null;
      state.fetched = true;
      state.fetchAttempted = true;
    },
    fetchTeamDirectoryFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.fetched = false;
      state.fetchAttempted = true;
    },
  },
});

export const {
  fetchTeamDirectoryRequest,
  fetchTeamDirectorySuccess,
  fetchTeamDirectoryFailure,
} = teamDirectorySlice.actions;

export default teamDirectorySlice.reducer;
